import { Link } from 'react-router-dom';
import { useCan } from '../useCan';
import { useCosts } from '../margin/useCosts';
import { boxContribution, minBoxFor } from '../../core/rules/margin';
import { euro, money, toCents } from '../../core/format/currency';

/** Gemiddelde brutomarge van Sarah's bijvulproducten (factuur Medik8: 35–46%). */
const BOX_MARGIN = 40;

/**
 * Onder het minimumbedrag van het Bewust Abonnement: wat een doos op dat minimum overlaat, het
 * advies voor haar eigen doel, en wat het cadeau per doos kost. Alleen met `finance.margin`.
 */
export function SubscriptionMarginHint({
  minBoxValue,
  giftEvery
}: {
  minBoxValue: number;
  giftEvery: number;
}) {
  const {
    canAll
  } = useCan();
  const allowed = canAll('finance.margin');
  const {
    data
  } = useCosts(allowed);
  if (!allowed || !data) return null;
  const c = data.costs;
  const left = boxContribution(toCents(minBoxValue), BOX_MARGIN, c);
  const advice = minBoxFor(c.targetBoxLeftCents, BOX_MARGIN, c);
  const giftPerBox = Math.round(c.subscriptionGiftCents / Math.max(1, giftEvery));
  return <div role="note" className="mt-6 rounded-md bg-sand/60 px-4 py-3 text-[13px] leading-relaxed text-ink" data-id="element-4459" data-mp="3hexxgrtzblb9">
      <p data-id="element-4460" data-mp="3cktpc58z978l">
        Een gemiddelde doos van {euro(minBoxValue)} laat ± {money(left)} over (bij {BOX_MARGIN}% brutomarge, het gemiddelde van je
        bijvulproducten; na incasso, pakket en verpakking). Per product staat de eigen marge bij het product.
        {advice !== null && ` Voor ${money(c.targetBoxLeftCents)} per doos: minimum ± ${euro(advice)}.`}
      </p>
      <p className="mt-1 text-muted" data-id="element-4461" data-mp="6ughnek1iq5">
        Het cadeau kost {c.subscriptionGiftCents === 0 ? '€ 0 (gratis van de leverancier)' : `${money(c.subscriptionGiftCents)}, gemiddeld ${money(giftPerBox)} per doos`}.{' '}
        <Link to="?tab=kosten" className="text-ink underline underline-offset-4" data-id="element-4462" data-mp="3mc7x10b31dct">
          Kosten aanpassen
        </Link>
      </p>
    </div>;
}